<template>
  <v-app id="inspire">
    <navigation v-if="isLoggedIn"></navigation>
    <v-main>
      <v-container fluid >
        <router-view/>
      </v-container>
    </v-main>
    <v-footer app color="primary">
      <span class="white--text">&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </v-app>
</template>

<script>
    import Navigation from './components/Navigation'
    import {mapGetters} from "vuex";

    export default {
        data: () => ({}),
        components: {Navigation},
      computed: {
        ...mapGetters({
          isLoggedIn : 'isLoggedIn',
          user: 'user'
        }),
      },
    }
</script>

<style lang="scss">
  .v-slide-group.text-right .v-slide-group__content{
    justify-content: right;
  }
</style>
